"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedOrders = exports.OrdersSelectTabs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var lodash_1 = __importDefault(require("lodash"));
var __1 = require("..");
var hooks_1 = require("../hooks");
var store_1 = require("../store");
var styles_1 = require("../styles");
var OrdersList_1 = __importDefault(require("../orders/OrdersList"));
function a11yProps(index) {
    return {
        id: "simple-tab-".concat(index),
        "aria-controls": "simple-tabpanel-".concat(index),
    };
}
var OrdersSelectTabs = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var _c = (0, __1.useTwapContext)(), translations = _c.translations, getOrdersTabsLabel = _c.uiPreferences.getOrdersTabsLabel;
    var _d = (0, store_1.useOrdersStore)(), tab = _d.tab, setTab = _d.setTab;
    var isMobile = (0, material_1.useMediaQuery)("(max-width:600px)");
    var tabs = (0, hooks_1.useOrdersTabs)();
    var handleChange = function (event, newValue) {
        setTab(newValue);
    };
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledOrdersTabs, __assign({ variant: "scrollable", scrollButtons: isMobile, className: "twap-orders-header-tabs ".concat(className), value: tab, onChange: handleChange }, { children: lodash_1.default.keys(tabs).map(function (key, index) {
            var name = translations[key] || key;
            var amount = tabs[key];
            var label = getOrdersTabsLabel ? getOrdersTabsLabel(name, amount) : "".concat(amount, " ").concat(name);
            return (0, jsx_runtime_1.jsx)(styles_1.StyledOrdersTab, __assign({ className: "twap-orders-header-tabs-tab", label: label }, a11yProps(index)), key);
        }) })));
};
exports.OrdersSelectTabs = OrdersSelectTabs;
var SelectedOrders = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var _c = (0, hooks_1.useOrdersHistoryQuery)(), orders = _c.orders, isLoading = _c.isLoading;
    var tab = (0, store_1.useOrdersStore)().tab;
    var tabs = (0, hooks_1.useOrdersTabs)();
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledOrdersLists, __assign({ className: "twap-orders-lists ".concat(className) }, { children: lodash_1.default.keys(tabs).map(function (key) {
            var tabValue = lodash_1.default.keys(tabs)[tab];
            var selected = tabValue === key;
            if (!selected)
                return null;
            if (tabValue === "All") {
                return (0, jsx_runtime_1.jsx)(OrdersList_1.default, { isLoading: isLoading, orders: lodash_1.default.flatMap(orders) }, key);
            }
            return (0, jsx_runtime_1.jsx)(OrdersList_1.default, { isLoading: isLoading, status: key, orders: orders[key] }, key);
        }) })));
};
exports.SelectedOrders = SelectedOrders;
